export const EDeliveryStatusType = {
  Pending: 0,

  Offered: 1,

  Accepted: 2,

  PickedUp: 3,

  OnRoute: 4,

  Delivered: 5,

  Rejected: 6,

  Expired: 7,

  Canceled: 8,
}

export type EDeliveryStatusType = (typeof EDeliveryStatusType)[keyof typeof EDeliveryStatusType]
